interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  name: string;
  options: RadioOption[];
  value: string;
  onChange: (name: string, value: string) => void;
  isRow?: boolean;
  label?: string;
}

export function RadioGroup({
  name,
  options,
  value,
  onChange,
  isRow = true,
  label,
}: RadioGroupProps) {
  const handleChange = (optionValue: string) => {
    onChange(name, optionValue);
  };

  return (
    <div className="flex items-center gap-3">
      {label && (
        <label className="text-sm font-medium text-neut-700">{label}</label>
      )}
      <div
        className={`flex items-center gap-3 ${isRow ? 'flex-wrap' : 'flex-col items-start'}`}
      >
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center gap-2 cursor-pointer"
          >
            <input
              type="radio"
              name={name}
              className="w-4 h-4 text-prim border-neut-300 focus:ring-prim"
              value={option.value}
              checked={value === option.value}
              onChange={() => handleChange(option.value)}
            />
            <span className="text-sm text-neut-700">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
